// extracted by mini-css-extract-plugin
export var Main = "Layouts-module--Main--1STyR";
export var ContentArea = "Layouts-module--ContentArea--1RLvU";
export var Content = "Layouts-module--Content--2rhUH";
export var UnboundedContent = "Layouts-module--UnboundedContent--3ZIf9";
export var Backdrop = "Layouts-module--Backdrop--1lKWz";